import { WorklistItemStatus } from 'generated/graphql';

// Single source of truth for the "Ready to Read" label.
export const READY_TO_READ_LABEL = 'Ready to Read';

// Search jacket priors show the raw backend status, and "Verified" is the Pending bucket
const VERIFIED_BACKEND_STATUS = 'Verified';

export type WorklistItemStatusLabels = Record<WorklistItemStatus, string> &
  Partial<Record<typeof VERIFIED_BACKEND_STATUS, string>>;

// Explicit map so QC stays an initialism and a new status breaks the build here.
const STATUS_LABELS: WorklistItemStatusLabels = {
  [WorklistItemStatus.Archive]: 'Archive',
  [WorklistItemStatus.ExternallyRead]: 'Externally Read',
  [WorklistItemStatus.InProgress]: 'In Progress',
  [WorklistItemStatus.InProgressAddendum]: 'In Progress Addendum',
  [WorklistItemStatus.InTransit]: 'In Transit',
  [WorklistItemStatus.Mismatched]: 'Mismatched',
  [WorklistItemStatus.Pending]: 'Pending',
  [WorklistItemStatus.Qc]: 'QC',
  [WorklistItemStatus.Scheduled]: 'Scheduled',
};

export function getWorklistItemStatusLabels({
  isReadyToReadEnabled,
}: {
  isReadyToReadEnabled: boolean;
}): WorklistItemStatusLabels {
  if (!isReadyToReadEnabled) return STATUS_LABELS;
  return {
    ...STATUS_LABELS,
    [WorklistItemStatus.Pending]: READY_TO_READ_LABEL,
    [VERIFIED_BACKEND_STATUS]: READY_TO_READ_LABEL,
  };
}

// The Pending worklist is renamed clinic by clinic, so it may have either name
export const PENDING_WORKLIST_NAMES = [
  STATUS_LABELS[WorklistItemStatus.Pending],
  READY_TO_READ_LABEL,
];

function isWorklistItemStatus(value: string): value is WorklistItemStatus {
  return value in STATUS_LABELS;
}

// Label for a status value. Unknown values are shown as-is
export function getWorklistItemStatusLabel({
  status,
  labels,
}: {
  status: Nullable<string>;
  labels: WorklistItemStatusLabels;
}): string {
  if (!status) return '';
  if (isWorklistItemStatus(status)) return labels[status];
  if (status === VERIFIED_BACKEND_STATUS) return labels[VERIFIED_BACKEND_STATUS] ?? status;
  return status;
}
